import styled from "styled-components";
import { themeModules } from "../../../../theme/theme.js"
import CancelIcon from '@mui/icons-material/Cancel';
import AutoSelect from '../../autoSelect.jsx';
import { useState,useEffect} from "react";
import { useSelector } from 'react-redux'
import { juegoSelected } from '../../../../redux/actions/juegoActions.js';
import Select from '@mui/material/Select';
import { LoadingButton } from '@mui/lab'; 
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import ConsolasAddGame from "./consolasAddGame.jsx"
import AvailableAccounts from "./availableAccounts.jsx"
import PersonIcon from '@mui/icons-material/Person';
import FormControl from '@mui/material/FormControl';
import api from '../../../../axios.js'





let Container=styled.div`
	position:absolute;
	top:0px;
	left:0px;
	height:100%;
	width:100%;
	z-index:3;
	display:flex;
	justify-content:center;
	align-items:center;
	color:white;

	
`;

const Backdrop=styled.div`
	background-color:${themeModules.background};
	width:100%;
	height:100%;
	position: absolute;
	opacity:0.8

`;

let Container2=styled.div`
	z-index:5;
	color:white;
	position:relative;
	width:95%;
	min-width:900px;
	min-height:550px;
	height:90%;
	background-color:${themeModules.panel};
	border-radius:8px;
	display:flex;
	flex-direction:column
`;

let Title=styled.div`
 	width:100%;
 	height:15%;
 	display:flex;
 	align-items:center;
 	justify-content:space-evenly;

 

`;

let ContainerDiv=styled.div`
	width:100%;
	display:flex;
	height:100%;
`;

let ContainerLeftSide=styled.div`
	width:45%;
	height:100%;
	display:flex;
	flex-direction:column;
	align-items:center;
`;

let ContainerRightSide=styled.div`
	width:52%;
	display:flex;
	justify-content:center;
	overflow:scroll;
	height:95%;
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.2); 
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
`;

let ContainerAttrs=styled.div`
	width:100%;
	display:flex;
	justify-content:center;
	flex-direction:column;

`;

let Poster=styled.div`
	width:80%;
	height:260px;
	background-size:cover;
	background-position:center;
	border-radius:8px;
	
`;

let DetailsAttrs=styled.div`
	display:flex;
	justify-content:space-evenly;
	width:100%;
	margin:10px

`;

let SearchButton=styled.div`
	display:flex;
	width:100%;
	justify-content:center;
	align-items:center;
	padding-top:15px
`;


const Close=styled.div`
	position:absolute;
	top:5vh;
	right:4vw;
	width:35px;
	font-size: 40px;
	z-index:6;
	
	&:hover{
	 	cursor:pointer
	 }
`;

let TopDiv=styled.div`
	height:15%;
	display:flex;
	justify-content:center;
	align-items:center
`;

let UserInfo=styled.div`
	display:flex;
	align-items:center;
	justify-content:space-between;
	min-width:140px
`;

let AccountInfo=styled.div`
	display:flex;
	align-items:center;
	justify-content:space-between;
	
	margin-left:10px
`;

let BotomDiv=styled.div`
	width:90%;
	height:85%;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:space-evenly
`;




export default function AddGameToUser(props){
	let {setOpen,user}=props;
	let [juegosName,setJuegosName]=useState([]);
	let [estados,setEstados]=useState({loading:false,tipoCuenta:"primaria"});
	let juegos=useSelector(state=>state.juego.juegos);
	let juegoSelectedRedux=useSelector(state=>state.juego.juegoSelected);
	let [consolaSelected,setConsolaSelected]=useState(0)
	let [accounts,setAccounts]=useState([])

	let estado=0


	useEffect(()=>{
 		if(estado===0){
 	 			let nombres=[];
 	 			juegos.map(ele=>ele.activo?nombres.push({label:`${ele.nombre}`,value:ele}):null) 	 	
 	 			setJuegosName(nombres);	
 		}
 	},[juegos,estado]);

	let handleChange=(e)=>{
		setEstados({...estados,tipoCuenta:e.target.value})
	}

	let searchAccounts=async()=>{
	
		let response= await api(`/cuenta/filterAccounts?gameId=${juegoSelectedRedux.id}&accountType=${estados.tipoCuenta}&consol=${consolaSelected}`);
		let accounts=response.data;
		setAccounts(accounts);

	}	
	return(
		<Container>
			<Backdrop/>
			<Close onClick={()=>setOpen(false)}><CancelIcon fontSize="40px"/></Close>
			<Container2>
				<Title>
					<div>Datos a buscar </div>
					<UserInfo ><div><PersonIcon sx={{ fontSize: 30}} /> </div>{user.nombre}<AccountInfo>({user.usuario})</AccountInfo></UserInfo>
					<div>Cuentas disponibles</div>
				</Title>
				<ContainerDiv>
					<ContainerLeftSide>
						<TopDiv>
							{juegosName.length>0?
							<AutoSelect data={juegosName}  id="juegos"  label="juegos"  disabled={false} action={juegoSelected} />
							:null}	
						</TopDiv>
						<BotomDiv>
							{juegoSelectedRedux.poster?<Poster style={{backgroundImage:`url(${juegoSelectedRedux.poster})`}}/>:null}
							{juegoSelectedRedux.Consolas?
								<ContainerAttrs>
									<DetailsAttrs>
										<ConsolasAddGame juegoSelectedRedux={juegoSelectedRedux} estado={estado} consola={consolaSelected} setConsola={setConsolaSelected}/>
										<FormControl>
											<InputLabel id="demo-simple-select-label">tipo cuenta</InputLabel>
											<Select  labelId="demo-simple-select-label" id="demo-simple-select"  value={estados.tipoCuenta} onChange={handleChange}  label="tipo cuenta" >
          											<MenuItem value="primaria">primaria</MenuItem>
          											<MenuItem value="secundaria">secundaria</MenuItem>
							 				</Select>
							 			</FormControl>
									</DetailsAttrs>	
							 		<SearchButton>
							 			<LoadingButton loading={estados.loading} disabled={consolaSelected==0} loadingPosition="start" startIcon={<SearchIcon />}  variant="contained" onClick={searchAccounts} > buscar </LoadingButton>
							 		</SearchButton>		
								</ContainerAttrs>
							:null}							
						</BotomDiv>
						
						
					</ContainerLeftSide>						
					<ContainerRightSide>
						{accounts.length>0?<AvailableAccounts accounts={accounts} userId={user.id} consola={consolaSelected} tipoCuenta={estados.tipoCuenta} setOpen={setOpen}/>:<div style={{color:"gray"}}>no hay cuentas disponibles</div>}
					</ContainerRightSide>
				</ContainerDiv>
			</Container2>

		</Container>


	)
}